<template>
  <div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    :class="{
      show: isOpen
    }"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      :class="{
        [`modal-${size}`]: !!size
      }"
      role="document"
    >
      <div class="modal-content">
        <div
          v-if="hasHeader"
          class="modal-header"
        >
          <h5
            id="exampleModalCenterTitle"
            class="modal-title"
          >
            {{ modalTitle }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeWindow"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot />
        </div>
        <div
          v-if="hasFooter"
          class="modal-footer"
        >
          <slot name="footer" />
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!canSubmit"
            @click.prevent="confirmOkay"
          >
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BootstrapModal',
  props: {
    hasHeader: {
      type: Boolean,
      default: true
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    modalTitle: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    canSubmit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    confirmOkay () {
      this.$emit('modal:okay')
    },
    closeWindow () {
      this.$emit('modal:close')
    }
  }
}
</script>
